import { Dialog } from "@ark-ui/react";
import Button from "../../Button/Button";
import Icon from "../../Icon/Icon";

export default function ModalCloseTrigger() {
  return (
    <Dialog.CloseTrigger asChild={true}>
      <Button iconOnly hierarchy="secondary-subtler">
        <Icon name="x" />
      </Button>
    </Dialog.CloseTrigger>
  );
}
